import { HttpTypes } from '@/types';
import { CreateInvoicePayload, CreateInvoiceResponse } from '@/types/http/domain';
import { IPaymentChannel, IPaymentChannels } from '@/types/payment';
import { AxiosInstance } from 'axios';

class Payment {
  private client: AxiosInstance;
  private routePath = '/sites';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async createDomainvoice(
    data: CreateInvoicePayload
  ): Promise<HttpTypes.IResponse<CreateInvoiceResponse>> {
    const response = await this.client.post('/sites/payment/buy-domain', data);
    return response.data;
  }

  async listPaymentMethod(): Promise<HttpTypes.IResponse<IPaymentChannels[]>> {
    const result = await this.client.get('/sites/payment-channel');
    return result.data;
  }

  async listActivePaymentMethodSetting(): Promise<HttpTypes.IResponse<IPaymentChannel[]>> {
    const res = await this.client.get(`${this.routePath}/payment-channel-store`);
    return res.data;
  }

  async updatePaymentSetting(data: HttpTypes.AdminUpdatePaymentMethodSetting) {
    const res = await this.client.post(`${this.routePath}/select-payment`, data);
    return res.data;
  }
}

export default Payment;
